import { render } from "./radioAlt.vue?vue&type=template&id=4f1ab52b"
import script from "./radioAlt.vue?vue&type=script&lang=js"
export * from "./radioAlt.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__